// `src/util/apiHelper.js`
export const postRequestReturnVoid = async (url, body) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        throw new CustomError(response.status, response.text());
    }
};

export const postRequest = async (url, body) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        throw new CustomError(response.status, response.text());
    }

    return await response.json();
};

export const getRequest = async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
        throw new CustomError(response.status, response.text());
    }
    return await response.json();
};

export class CustomError extends Error {
    constructor(status, body) {
        super(`Error: ${status}`);
        this.status = status;
        this.body = body;
    }
}